import React from 'react';
import { Link } from 'react-router-dom';
import { Image } from '../../Image';
import { Placeholder, PlaceholderOverlay, InnerLink, AspectRatioContent, PlayIcon, NewHighlight } from '../../Videos/partials';
import { getArticlePath, getArticleRel } from './../../Articles';
export var Podcast = function Podcast(_ref) {
  var podcast = _ref.podcast,
    _ref$playIconSize = _ref.playIconSize,
    playIconSize = _ref$playIconSize === void 0 ? 'medium' : _ref$playIconSize,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Podcast' : _ref$title,
    withNew = _ref.withNew,
    withPlayIcon = _ref.withPlayIcon;
  var url = getArticlePath(podcast);
  var rel = getArticleRel(podcast);
  return React.createElement(InnerLink, {
    as: Link,
    to: url,
    rel: rel
  }, React.createElement(Placeholder, {
    withShadow: true
  }, React.createElement(AspectRatioContent, {
    withNew: withNew
  }, withNew ? React.createElement(NewHighlight, null, "Nuevo") : null, React.createElement(Image, {
    src: podcast.image,
    alt: title
  })), withPlayIcon && React.createElement(PlaceholderOverlay, {
    iconSize: playIconSize
  }, React.createElement(PlayIcon, null))));
};